import React from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import BRSRSidebar from "../../../Layout/BRSRSidebar";
import SectionB from "./SectionB";

const index = () => {
  return (
    <MainDashboardLayout sidebar={<BRSRSidebar />}>
      <SectionB />
    </MainDashboardLayout>
  );
};

export default index;
